"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DVCClient = void 0;
var Variable_1 = require("./Variable");
var Request_1 = require("./Request");
var Store_1 = __importDefault(require("./Store"));
var User_1 = require("./User");
var EventQueue_1 = require("./EventQueue");
var utils_1 = require("./utils");
var EventEmitter_1 = require("./EventEmitter");
var DVCClient = /** @class */ (function () {
    function DVCClient(environmentKey, user, options) {
        var _this = this;
        this.store = new Store_1.default(window.localStorage);
        this.user = user;
        this.options = options;
        this.environmentKey = environmentKey;
        this.variables = [];
        this.eventQueue = new EventQueue_1.EventQueue(environmentKey, this, options === null || options === void 0 ? void 0 : options.flushEventsMS);
        this.eventEmitter = new EventEmitter_1.EventEmitter();
        this.store.saveUser(user)
            .then(function () { return console.log('Successfully saved user to local storage!'); });
        this.onInitialized = (0, Request_1.getConfigJson)(environmentKey, user)
            .then(function (config) {
            _this.config = config;
            _this.store.saveConfig(config)
                .then(function () { return console.log('Successfully saved config to local storage'); });
            _this.eventEmitter.emitInitialized(true);
            return _this;
        })
            .catch(function (err) {
            _this.eventEmitter.emitInitialized(false);
            _this.eventEmitter.emitError(err);
            return _this;
        });
    }
    DVCClient.prototype.onClientInitialized = function (onInitialized) {
        if (onInitialized && typeof onInitialized === 'function') {
            this.onInitialized
                .then(function () { return onInitialized(); })
                .catch(function (err) { return onInitialized(err); });
            return null;
        }
        return this.onInitialized;
    };
    DVCClient.prototype.variable = function (key, defaultValue) {
        var _this = this;
        var _a, _b;
        var data = __assign({ key: key, defaultValue: defaultValue }, (_b = (_a = this.config) === null || _a === void 0 ? void 0 : _a.variables) === null || _b === void 0 ? void 0 : _b[key]);
        var variable = new Variable_1.DVCVariable(data);
        this.variables.push(variable);
        this.onInitialized.then(function () {
            var _a, _b, _c;
            (_a = variable.callback) === null || _a === void 0 ? void 0 : _a.call(variable, (_c = (_b = _this.config) === null || _b === void 0 ? void 0 : _b.variables[key]) === null || _c === void 0 ? void 0 : _c.value);
        });
        try {
            this.eventQueue.queueAggregateEvent({
                type: variable.isDefaulted
                    ? EventQueue_1.EventTypes.variableDefaulted
                    : EventQueue_1.EventTypes.variableEvaluated,
                target: variable.key,
            });
        }
        catch (e) {
            this.eventEmitter.emitError(e);
            console.log('Error with queueing aggregate events', e);
        }
        return variable;
    };
    DVCClient.prototype.identifyUser = function (user, callback) {
        var _this = this;
        var promise = new Promise(function (resolve, reject) {
            try {
                _this.eventQueue.flushEvents();
                var updatedUser_1;
                if (user.user_id === _this.user.user_id) {
                    updatedUser_1 = _this.user.updateUser(user);
                }
                else {
                    updatedUser_1 = new User_1.DVCUser(user);
                }
                (0, Request_1.getConfigJson)(_this.environmentKey, updatedUser_1)
                    .then(function (config) {
                    _this.config = config;
                    _this.store.saveConfig(config)
                        .then(function () { return console.log('Successfully saved config to local storage'); });
                    return config.variables;
                })
                    .then(function (variables) {
                    _this.user = updatedUser_1;
                    _this.store.saveUser(updatedUser_1)
                        .then(function () { return console.log('Successfully saved user to local storage!'); });
                    return resolve(variables);
                })
                    .catch(function (err) { return Promise.reject(err); });
            }
            catch (err) {
                _this.eventEmitter.emitError(err);
                reject(err);
            }
        });
        if (callback && typeof callback == 'function') {
            promise.then(function (variables) { return callback(null, variables); })
                .catch(function (err) { return callback(err, null); });
            return null;
        }
        return promise;
    };
    DVCClient.prototype.resetUser = function (callback) {
        var _this = this;
        var promise = this.store.loadAnonUser().then(function (anonUser) {
            try {
                _this.eventQueue.flushEvents();
                var updatedUser_2 = anonUser ? new User_1.DVCUser(JSON.parse(anonUser)) : new User_1.DVCUser({ isAnonymous: true });
                return (0, Request_1.getConfigJson)(_this.environmentKey, updatedUser_2)
                    .then(function (config) {
                    _this.config = config;
                    _this.user = updatedUser_2;
                    _this.store.saveConfig(config).then(function () {
                        console.log('Successfully saved config to local storage');
                    });
                    _this.store.saveUser(updatedUser_2).then(function () {
                        console.log('Successfully saved user to local storage!');
                    });
                    return config.variables;
                }).catch(function (e) {
                    throw new Error(e);
                });
            }
            catch (e) {
                _this.eventEmitter.emitError(e);
                throw new Error(e);
            }
        });
        if (callback && typeof callback == 'function') {
            promise.then(function (variables) { return callback(null, variables); })
                .catch(function (err) { return callback(err, null); });
            return null;
        }
        return promise;
    };
    DVCClient.prototype.allFeatures = function () {
        var _a;
        return ((_a = this.config) === null || _a === void 0 ? void 0 : _a.features) || {};
    };
    DVCClient.prototype.allVariables = function () {
        var _a;
        return ((_a = this.config) === null || _a === void 0 ? void 0 : _a.variables) || {};
    };
    DVCClient.prototype.subscribe = function (key, handler) {
        this.eventEmitter.subscribe(key, handler);
    };
    DVCClient.prototype.unsubscribe = function (key, handler) {
        this.eventEmitter.unsubscribe(key, handler);
    };
    DVCClient.prototype.track = function (event) {
        var _this = this;
        (0, utils_1.checkParamDefined)('type', event.type);
        this.onInitialized.then(function () {
            _this.eventQueue.queueEvent(event);
        });
    };
    DVCClient.prototype.flushEvents = function (callback) {
        return this.eventQueue.flushEvents().then(function () { return callback === null || callback === void 0 ? void 0 : callback(); });
    };
    return DVCClient;
}());
exports.DVCClient = DVCClient;
//# sourceMappingURL=Client.js.map